import { jsx, jsxs } from 'react/jsx-runtime';
import { navigationBarItemContainerStyles, navigationBarItemStyles, navigationBarIconContainer, navigationBarIconInnerContainer, navItemLabelContainer } from './navigation-bar-item-styles.js';
import { cx } from 'class-variance-authority';
import React from 'react';

function fixedForwardRef(render) {
    return React.forwardRef(render);
}
const BaseNavItem = (props, ref) => {
    const { bold, className, icon, label, as, endAdornment, isActive, isExpanded, ...rest } = props;
    const Component = as || "div";
    return (jsx("li", { className: navigationBarItemContainerStyles(), children: jsxs(Component, { className: cx(navigationBarItemStyles({ isActive, bold }), className), ref: ref, ...rest, children: [icon && (jsx("div", { className: navigationBarIconContainer(), children: jsx("div", { className: navigationBarIconInnerContainer(), children: icon }) })), jsx("div", { className: cx(navItemLabelContainer({
                        screenReaderOnly: !isExpanded,
                    })), children: label }), endAdornment && (jsx("div", { className: navigationBarIconContainer(), children: jsx("div", { className: navigationBarIconInnerContainer(), children: endAdornment }) }))] }) }));
};
const NavigationBarItem = fixedForwardRef(BaseNavItem);

export { NavigationBarItem };
